export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70926b35a8fee0bbc3fb4f1cea8bd0d3312a2067e0&name=pushAdClickData!'